var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.799 2.799A2.727 2.727 0 016.727 2H14a.91.91 0 01.643.266l5.454 5.455c.17.17.267.402.267.643v10.909A2.727 2.727 0 0117.636 22H6.727A2.727 2.727 0 014 19.273V4.727c0-.723.287-1.417.799-1.928zm1.928 1.02a.91.91 0 00-.909.908v14.546a.91.91 0 00.91.909h10.908a.91.91 0 00.91-.91V8.74l-4.923-4.922H6.727z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2a.91.91 0 01.909.91v4.545h4.545a.91.91 0 010 1.818H14a.91.91 0 01-.91-.91V2.91A.91.91 0 0114 2zM7.636 12.91a.91.91 0 01.91-.91h7.272a.91.91 0 110 1.818H8.545a.91.91 0 01-.909-.909zM7.636 16.545a.91.91 0 01.91-.909h7.272a.91.91 0 110 1.819H8.545a.91.91 0 01-.909-.91zM7.636 9.273a.91.91 0 01.91-.91h1.818a.91.91 0 110 1.819H8.544a.91.91 0 01-.909-.91z",
    fill: "current"
  })));
}
export default SvgFile;